<template>
  <div>
    <v-modal-table :columns="columns" :sizes="[2, 4, 2, 2, 2]">
      <user-row v-for="user in users" :user="user" :key="user.id" slot="table-body" />
    </v-modal-table>

    <portal-target name="userTableModal"></portal-target>
  </div>
</template>

<script>
import UserRow from '@/views/UsersView/components/UserRow';
import VModalTable from '@/components/ui/VModalTable';

export default {
  name: 'UsersTable',
  components: {
    UserRow,
    VModalTable,
  },
  data() {
    return {
      columns: ['CreditorId', 'Email', 'First Name', 'Last Name', 'Comment'],
      displaySuppliers: false,
    };
  },
  props: {
    users: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss"></style>
